/**
 * The marks on the phone's three pane buttons: chemicals, apparatus, steps.
 *
 * Drawn rather than emoji. An emoji is whatever the platform's font says it is
 * — a green tube on one phone, a pink one on the next — and it ignores the
 * button's colour, so the pressed button could not be told from the others by
 * its mark. These inherit `currentColor` and sit on the same 16-unit grid as
 * the block marks beside them.
 */

/** A test tube, tilted, with something in it. */
export function ChemicalsIcon(): React.JSX.Element {
    return (
        <svg viewBox="0 0 16 16" width="1em" height="1em" aria-hidden="true" focusable="false">
            <g transform="rotate(35 8 8)">
                <path
                    d="M6 1.5 v10 a2 2 0 0 0 4 0 v-10"
                    fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round"
                />
                <path d="M5 1.5 h6" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
                <path d="M6.65 7.5 v4 a1.35 1.35 0 0 0 2.7 0 v-4 Z" fill="currentColor" opacity="0.55" />
            </g>
        </svg>
    );
}

/** A conical flask on a stand's base — glassware, and what holds it. */
export function ApparatusIcon(): React.JSX.Element {
    return (
        <svg viewBox="0 0 16 16" width="1em" height="1em" aria-hidden="true" focusable="false">
            <path
                d="M6.4 1.8 v3.6 L3.2 11.6 a1 1 0 0 0 .9 1.4 h7.8 a1 1 0 0 0 .9 -1.4 L9.6 5.4 V1.8"
                fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinejoin="round" strokeLinecap="round"
            />
            <path d="M5.6 1.8 h4.8" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
            <path d="M1.8 15 h12.4" fill="none" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
        </svg>
    );
}

/** A page of ruled steps, the first one ticked. */
export function StepsIcon(): React.JSX.Element {
    return (
        <svg viewBox="0 0 16 16" width="1em" height="1em" aria-hidden="true" focusable="false">
            <rect x="2.5" y="1.5" width="11" height="13" rx="2"
                fill="none" stroke="currentColor" strokeWidth="1.3" />
            <path d="M4.8 5.2 l1 1 l1.7 -1.9" fill="none" stroke="currentColor" strokeWidth="1.2"
                strokeLinecap="round" strokeLinejoin="round" />
            <path d="M9 5.4 h2.4 M4.8 8.6 h6.6 M4.8 11.4 h6.6" fill="none" stroke="currentColor"
                strokeWidth="1.2" strokeLinecap="round" />
        </svg>
    );
}
